import { Component, HostBinding, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IconDirective } from '../../directives/icon.directive';

@Component({
  selector: 'lv-script-toggle',
  styleUrls: ['script-toggle.component.scss'],
  templateUrl: 'script-toggle.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [TranslateModule, IconDirective]
})
export class ScriptToggleComponent {
  @HostBinding('class.is-visible') _open = false;

  toggleScript() {
    this._open = !this._open;
  }
}
